import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})
export class ApplicationsComponent implements OnInit {
  private perPage=5;
  public availableFilters=[];
  private filterString='filter[status]=pending';
  public paginatedApplications = new BehaviorSubject<any>(null);
  public loadingApplications:boolean=true;

  constructor(
    private _accounts: AccountService
  ) {
    this.availableFilters.push(new FilterOption({name:'practice_name',type:'string'}));
    this.availableFilters.push(new FilterOption({name:'user.email',type:'string'}));
    this.availableFilters.push(new FilterOption({
      name:'status',
      type:'select',
      'options':[
        {name:'Pending',value:'pending'},
        {name:'Accepted',value:'accepted'},
        {name:'Rejected', value:'rejected'}
      ],
      default: 'pending'
    }));
  }

  ngOnInit() {
    this.getApplications(1);
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getApplications(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getApplications(1);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getApplications(1);
  }

  public getApplications(page){
    this._accounts.getApplications(page,this.perPage,this.filterString).subscribe(
      paginatedData=>{
        this.paginatedApplications.next(paginatedData);
        this.loadingApplications=false;
      }
    );
  }
}
